import {del, get, post, put} from "../helpers/api_helper";
import {
    IExo,
    IExoForm,
    IExoPagination, IExoReplacer, IExoReplacerForm, IExoReplacerPagination,
    IExoTemplate,
    IExoTemplateForm,
    IExoTemplatePagination
} from "../store/exo/types";

export const ExoService = {
    getAll: async (filter: any): Promise<IExoPagination> => {
        return get("/echo-notifications", {params: filter})
    },

    getById: async (id: number): Promise<IExo> => {
        return get(`/echo-notifications/${id}`)
    },

    toggleById: async (id: number): Promise<IExo> => {
        return get(`/echo-notifications/${id}/toggle`)
    },

    create: async (data: IExoForm) => {
        return post(`/echo-notifications`, data)
    },

    update: async (id: number, data: IExoForm) => {
        return put(`/echo-notifications/${id}`, data)
    },

    remove: async (id: number) => {
        return del(`/echo-notifications/${id}`)
    },

    // Templates
    getAllTemplates: async (filter?: any): Promise<IExoTemplatePagination> => {
        return get("/echo-templates", {params: filter})
    },

    getByIdTemplate: async (id: number): Promise<IExoTemplate> => {
        return get(`/echo-templates/${id}`)
    },

    createTemplate: async (data: IExoTemplateForm) => {
        return post(`/echo-templates`, data)
    },

    updateTemplate: async (id: number, data: IExoTemplateForm) => {
        return put(`/echo-templates/${id}`, data)
    },

    removeTemplate: async (id: number) => {
        return del(`/echo-templates/${id}`)
    },

    // Replacer
    getAllReplacers: async (filter?: any): Promise<IExoReplacerPagination> => {
        return get("/echo-replacers", {params: filter})
    },

    getByIdReplacer: async (id: number): Promise<IExoReplacer> => {
        return get(`/echo-replacers/${id}`)
    },

    createReplacer: async (data: IExoReplacerForm) => {
        return post(`/echo-replacers`, data)
    },

    updateReplacer: async (id: number, data: IExoReplacerForm) => {
        return put(`/echo-replacers/${id}`, data)
    },

    removeReplacer: async (id: number) => {
        return del(`/echo-replacers/${id}`)
    },
}